import { render } from "./tabs-csv.vue?vue&type=template&id=ae48fb22&ts=true"
import script from "./tabs-csv.vue?vue&type=script&lang=ts"
export * from "./tabs-csv.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__